import { Adapter as t } from "../../../../adapter.js";
import { KioskConfigurationInactiveModel as o } from "./kioskConfigurationInactive.model.js";
class m extends t {
  adapt(e) {
    var i;
    return new o({
      settings: {
        reloadTime: ((i = e == null ? void 0 : e.settings) == null ? void 0 : i.reload_time) ?? 10,
        inactiveTime: e.settings.inactive_time ?? 50
      },
      text: (e == null ? void 0 : e.text) ?? {}
    });
  }
  serialize(e) {
    throw new Error("Method not implemented.");
  }
}
export {
  m as KioskConfigurationInactiveAdapter
};
//# sourceMappingURL=kioskConfigurationInactive.adapter.js.map
